import { Button, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/GlobalActions';
import { useTranslation } from 'react-i18next';

export function Welcome() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleNext = () => {
    dispatch({ type: actions.NEXT_REGISTRATION_STEP });
  };
  return (
    <>
      <Typography variant="h5" align="center" sx={{ marginBottom: 10 }}>
        {t('registration_start')}
      </Typography>
      <Button sx={{ width: '100%' }} variant="contained" color="primary" onClick={handleNext}>
        {t('continue')}
      </Button>
    </>
  );
}
